/**
 * direktPostNutzlast — baut die Nutzlast für POST /live-posting/publish-direct.
 *
 * Warum als eigene Funktion (Befund 14.08.2026): Der Sammel-Knopf im Monatsplan schickte
 * den Hook ZWEIMAL — einmal als ersten Absatz von `text`, einmal noch als `title`. Die
 * Route setzt den Titel aber als Hook VOR den Text:
 *
 *     routes.py:328   content = {"hook": request.title or "", "body": request.text, ...}
 *     unified_dispatcher.py:943   full_text = f"{hook}\n\n{body}\n\n{cta}"
 *
 * Ergebnis: „Hook / Hook / Body / CTA" — derselbe Absatz zweimal. Der Dublettenriegel
 * (unified_dispatcher.hat_dublette, gebaut nach dem Vorfall vom 07.08.) hat das korrekt
 * abgefangen und den Versand verweigert. Gemessen am echten Bestand des Owner-Workspaces:
 * MIT title 19 von 19 Beiträgen abgewiesen, OHNE title 0 von 19. Der Sammel-Versand konnte
 * also nie funktionieren — am 14.08. um 15:24 scheiterten so 10 Versuche in sieben Sekunden.
 *
 * Der Titel wird bewusst NICHT mehr gesetzt: Für LinkedIn ist er ohnehin nur die
 * Beschriftung des Bild-Anhangs (unified_dispatcher.py:520), für Facebook ohne Wirkung —
 * für den Text ist er reine Verdopplung.
 */

/**
 * @param post  Ein Beitrag aus dem Monatsplan (volles Dokument, NICHT der gekürzte
 *              Kalender-Eintrag: dessen `hook` endet nach 40 Zeichen mit „…", und
 *              Textkörper hat er gar keinen — server.py:1168).
 * @returns {{ text, hashtags, title }|{ fehler }} — `fehler` nennt den Grund, wenn der
 *          Beitrag keinen sendbaren Inhalt hat.
 */
export function direktPostNutzlast(post) {
  const hook = (post?.hook || "").trim();
  const body = (post?.body || post?.core_content || post?.text_content || "").trim();
  const cta = (post?.cta || "").trim();
  const contentField = (post?.content || "").trim();

  let text;
  let hashtagsAnhaengen;
  if (hook || body || cta) {
    text = [hook, body, cta].filter(Boolean).join("\n\n");
    hashtagsAnhaengen = true;
  } else if (contentField) {
    text = contentField;
    hashtagsAnhaengen = false;
  } else {
    return { fehler: "Post hat keinen Text-Inhalt" };
  }

  return {
    text,
    hashtags: hashtagsAnhaengen && Array.isArray(post?.hashtags) ? post.hashtags : [],
    // Immer null: siehe Kopf. Der Hook steht bereits in `text`.
    title: null,
  };
}
